// import axios from 'axios';
import http from '../http-common';
import authHeader from './auth-header';

// const API_URL = 'https://opprop.andro.no/api/test/';
// const API_URL2 = 'https://opprop.andro.no/api/';
// const API_URL = 'http://localhost:8080/api/test/';
// const API_URL2 = 'http://localhost:8080/api/';
const API_URL = '/api/test/';
const API_URL2 = '/api/';

class UserService {
  getPublicContent() {
    return http.get(API_URL + 'all');
  }

  getParticipantBoard(competition_id, participant_id, user_type) {
    if ( user_type == 'mod') {
      return http.get(API_URL2 + `mod/competition/${competition_id}/participant/${participant_id}`, { headers: authHeader() });
    } else {
      return http.get(API_URL2 + `competition/${competition_id}/participant/${participant_id}`, { headers: authHeader() });
    }
  }

  getFrisysJson({ url, label }) {
    http.get(url, { responseType: 'blob', headers: authHeader() })
    .then(response => {
      const blob = new Blob([response.data], { type: 'application/json' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = label
      link.click()
      URL.revokeObjectURL(link.href)
    }).catch(console.error);
}

  getParticipantsBoard(competition_id) {
    return http.get(API_URL2 + `competition/${competition_id}/participants/all`, { headers: authHeader() });
  }

  getTeamsBoard(competition_id) {
    return http.get(API_URL2 + `competition/${competition_id}/teams/all`, { headers: authHeader() });
  }

  getTeamBoard(competition_id, team) {
    return http.get(API_URL2 + `competition/${competition_id}/teams/`+encodeURIComponent(team), { headers: authHeader() });
  }

  getEventsBoard(competition_id) {
    return http.get(API_URL2 + `competition/${competition_id}/events/all`, { headers: authHeader() });
  }

  // getTeamsBoard() {
  //   return http.get(API_URL2 + `competition/${this.$store.state.auth.currentCompetition}/teams/all`, { headers: authHeader() });
  // }

  getEventBoard(competition_id, event_id) {
    // // Add debug delay of x seconds
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     resolve(http.get(API_URL2 + `competition/${competition_id}/eventswithcallroom/${event_id}`, { headers: authHeader() }));
    //   }, 6000);
    // });

    return http.get(API_URL2 + `competition/${competition_id}/eventswithcallroom/${event_id}`, { headers: authHeader() });
  }

  getUserBoard() {
    return http.get(API_URL + 'user', { headers: authHeader() });
  }

  getModeratorBoard(competition_id) {
    return http.get(API_URL2 + `competition/${competition_id}/admin`, { headers: authHeader() });
  }

  getAdminBoard() {
    return http.get(API_URL + 'admin', { headers: authHeader() });
  }

  toggleRole(role, competition_id) {
    console.log("toggleRole: "+role + " - " + competition_id);
    return http.get(API_URL2 + 'admin_toggle_role/' + role + (competition_id ? '/' + competition_id : ''), { headers: authHeader() });
  }
}

export default new UserService();